import _memoize from 'lodash/memoize';
import { makeThemeColor, TERTIARY } from '@tornado-rdk/theme';
import { FONT, getFont } from '@tornado-rdk/typography';
import { FULL_HD, HD, safetyMargins } from '@bedrock-rdk/constants';
import { makeDefaultStylingContext } from '../../tornado/utils/style';
import { SCREEN_HEIGHT, SCREEN_WIDTH, middle } from '../../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const CONTENT_SIDE_MARGIN = {
  [HD]: 320,
  [FULL_HD]: 480,
};

export const DESCRIPTION_TOP_MARGIN = {
  [HD]: 8,
  [FULL_HD]: 16,
};

export const BUTTONS_TOP_MARGIN = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const LOGO_HEIGHT = {
  [HD]: 64,
  [FULL_HD]: 72,
};

export const LOGO_OFFSET_TOP = {
  ...safetyMargins.vertical,
};

export const colors = {
  background: makeThemeColor(TERTIARY),
};

export const getInitialStyle = _memoize((context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const titleFont = getFont(FONT.KINSHASA_3, screenSize);
  const descriptionFont = getFont(FONT.OTTAWA_2, screenSize);
  const wordWrapWidth = SCREEN_WIDTH[screenSize] - CONTENT_SIDE_MARGIN[screenSize] * 2;

  return {
    rect: true,
    color: colors.background[colorMode],
    h: SCREEN_HEIGHT[screenSize],
    w: SCREEN_WIDTH[screenSize],
    Icon: {
      x: middle,
      y: LOGO_OFFSET_TOP[screenSize],
      mountX: 0.5,
      textureScale: 1.5,
      h: LOGO_HEIGHT[screenSize],
    },
    FlexContainer: {
      x: middle,
      y: middle,
      mountY: 0.5,
      flex: { direction: 'column', justifyContent: 'center' },
      Title: {
        mountX: 0.5,
        text: {
          textAlign: 'center',
          wordWrapWidth,
          maxLines: 5,
          maxLinesSuffix: '...',
          ...titleFont,
        },
      },
      Description: {
        flexItem: { marginTop: DESCRIPTION_TOP_MARGIN[screenSize] },
        mountX: 0.5,
        text: {
          textAlign: 'center',
          wordWrapWidth,
          ...descriptionFont,
        },
      },
      OkButton: {
        flexItem: { marginTop: BUTTONS_TOP_MARGIN[screenSize] },
        mountX: 0.5,
        colorMode,
      },
    },
  };
});
